import { render, staticRenderFns } from "./She.vue?vue&type=template&id=b16393a8&scoped=true&"
import script from "./She.vue?vue&type=script&lang=js&"
export * from "./She.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16393a8",
  null
  
)

export default component.exports